import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import ActionButtonTemplate from './ActionButtonTemplate'
import { lang } from '../../assets/lang'

export default class ActionButtonComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.ACTION_BUTTON)

    this.is_system_generated_action = !! window.xitFlowBuilderData.is_system_generated_action

    if (this.is_system_generated_action) {
      this.data.noContextMenu = true
    }

    this.data.component = ActionButtonTemplate
    this.socket = config ? config.sockets : null
  }

  builder(node) {
    node.lingualName = lingualName.ACTION_BUTTON
    this.setConnection()

    const actionButtonOutput = new Rete.Output(
      CONST_SOCKET.ACTION_BUTTON_OUTPUT, 
      lang.action_button_socket_output_next, 
      this.socket.actionButtonOutput, 
      false
    )
    
    return node
      .addOutput(actionButtonOutput)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {}

  setConnection() {
    this.socket.actionButtonOutput.combineWith(this.socket.referenceInputActionButton)
  }
}